import React from 'react';

export const SoundEncodingIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 12C5 5 7 5 10 12C13 19 15 19 18 12C20 7 21 7 22 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.6"/>
    <circle cx="4" cy="7.33" r="1.5" fill="currentColor" />
    <circle cx="7" cy="7.33" r="1.5" fill="currentColor" />
    <circle cx="10" cy="12" r="1.5" fill="currentColor" />
    <circle cx="13" cy="16.67" r="1.5" fill="currentColor" />
    <circle cx="16" cy="16.67" r="1.5" fill="currentColor" />
    <circle cx="19" cy="9" r="1.5" fill="currentColor" />
  </svg>
);